<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <!-- <map-nav-bar :pz="'left-top'" :btmList="btmList" /> 
    <b-nav></b-nav>-->
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
// 产业亮点
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
import cDetail from "../util/detail";
// import bNav from "../util/bnav"; // 删除底部“加工、物流、冷链、出口”模块
import { cyldMixin } from "@/util/mixin/cyldMixin";
import { findOrgCompanyByType } from "@/api/map";
import { mapGetters } from "vuex";
export default {
  mixins: [cyldMixin],
  components: {
    cDetail,
  },
  computed: {
    ...mapGetters(["maptype"]),
  },
  watch: {
    maptype(v) {
      if (v) {
        this.getLd();
      }
    },
  },
  data() {
    return {
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      kjArr: [],
      zhwlArr: [],
      ydArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      baseList: [],
      zhwlList: [],
      hoverArr: [],
      beltObj: {},
      areaList: [],
      mianArr: [],
      //   btmList: [
      //     {
      //       name: "红色区域为茂名市荔枝优势产区产业园（荔枝种植面积40万亩）",
      //       pic: require("images/map/red.jpg")
      //     },
      //     {
      //       name: "粉色区域为茂名荔枝主产区（面积超过10000亩以上镇街）",
      //       pic: require("images/map/fs.jpg")
      //     },
      //     {
      //       name: "浅粉色区域为茂名荔枝产区（面积超过1000亩以上镇街）",
      //       pic: require("images/map/dfs.jpg")
      //     },
      //     {
      //       name: "一会、一圃、一馆、一园、一网、一站",
      //       pic: require("images/map/gy2.png")
      //     }
      //   ]
    };
  },
  mounted() {
    this.initMap();
    this.t61List = [];
  },
  methods: {
    changeMap(url) {
      // 修改切片图层
      this.removemap2();
      if (url) {
        this.tileMapLayer2 = esri.tiledMapLayer({
          url: url,
        });
        window.map.addLayer(this.tileMapLayer2);
      }
    },
    removemap2() {
      // 删除切片图层
      if (this.tileMapLayer2) {
        this.tileMapLayer2._container.remove();
        this.tileMapLayer2.remove();
        this.tileMapLayer2 = null;
      }
    },
    initMap() {
      //   var url = require("images/map/dt1.png");
      //   var map = L.map("map", {
      //     minZoom: 17,
      //     maxZoom: 20,
      //     center: [-0.00200653076171875, 0.0021896362304687],
      //     zoom: 17,
      //     crs: L.CRS.Simple,
      //     attributionControl: false
      //   });
      // var map = L.map("map", {
      //         crs: CRS_4490,
      //         minZoom: this.$config.sZoom,
      //         maxZoom: this.$config.mZoom,
      //         zoomControl: false
      //       });
      // 加载底图
      let tileMapUrl = this.$config.tileMapUrl;
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998],
        }
      );
      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false,
      });

      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl,
      });
      tileMapLayer.addTo(map);
      this.map.setView(L.latLng(22.01881208625042, 110.94832427275242), 0);
      this.changeMap(
        window.__config.VUE_APP_MAP_URL +
          "/rest/services/440900/mm_lz_02/MapServer"
      );
      //   var northEast = this.map.unproject([2271, 0], this.map.getMaxZoom() - 1); //东北 右上角northEast
      //   var southWest = this.map.unproject([0, 2406], this.map.getMaxZoom() - 1); //西南 左下角southWest
      //   var bounds = new L.LatLngBounds(southWest, northEast);
      //   L.imageOverlay(url, bounds, { interactive: false }).addTo(map);
      // map.setMaxBounds(bounds);//设置了地图和图片一样大小，取消之后，自定义地图可以随意拖拽
      this.nowZoom = this.map.getZoom();
      map.on("click", (e) => {
        console.log(e.latlng);
      });
    },
    //加载标记点数据
    dataLoad() {
      this.getLd();
    },
    // 地图点加载
    getLd() {
      if (this.maptype === "ly") {
        get("/api/restful/zzjd/getIndustryBrightSpot", { id: "" }).then(
          (res) => {
            this.pointList = res.data.map((e) => {
              return {
                id: e.id,
                longitude: e.by1_,
                latitude: e.by2_,
                name: e.name_,
                qyjs: e.body_,
                orgCompanyFiles: [{ address: e.pic_ }],
              };
            });
            this.pointLoad();
          }
        );
      } else {
        findOrgCompanyByType({ type: 9 }).then((res) => {
          this.pointList = res.data;
          this.pointLoad();
        });
      }
    },

    //科技中心数据加载
    pointLoad() {
      if (this.pointLayer) {
        this.map.removeLayer(this.pointLayer);
      }
      this.pointLayer = new L.layerGroup();
      let jxarr = [];
      // 解析图片
      if (this.maptype === "ly") {
        jxarr = [
          {
            name: "中国荔枝博物馆",
            fximg: require("images/map/ld/向下.png"),
            className: "top",
          },
          {
            name: "国家荔枝种质资源圃",
            fximg: require("images/map/ld/右上.png"),
            className: "right-top",
          },
          {
            name: "智慧荔园",
            fximg: require("images/map/ld/右下.png"),
            className: "right-btm",
          },
          {
            name: "中国荔枝产业大会会址",
            fximg: require("images/map/ld/右下.png"),
            className: "right-btm",
          },
          {
            name: "田头小站",
            fximg: require("images/map/ld/右下0.png"),
            className: "right-btm0",
          },
          {
            name: "中国荔枝产业大会",
            fximg: require("images/map/ld/左上.png"),
            className: "left-top",
          },
          {
            name: "产业园信息管理平台",
            fximg: require("images/map/ld/左下.png"),
            className: "left-btm",
          },
        ];
      } else {
        jxarr = [
          {
            name: "泗水滩底古荔园",
            fximg: require("images/map/ld/向下.png"),
            className: "top",
          },
          {
            name: "根子柏桥贡园",
            fximg: require("images/map/ld/右上.png"),
            className: "right-top",
          },
          {
            name: "霞洞上河古荔园",
            fximg: require("images/map/ld/右下.png"),
            className: "right-btm",
          },
          {
            name: "五化果园",
            fximg: require("images/map/ld/左上.png"),
            className: "left-top",
          },
          {
            name: "羊角禄段古荔园",
            fximg: require("images/map/ld/左下.png"),
            className: "left-btm",
          },
          {
            name: "智慧荔园",
            fximg: require("images/map/ld/右下0.png"),
            className: "right-btm0",
          },
        ];
      }
      let pointUrl = require("images/map/gy2.png");
      this.pointList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;

          var myIcons = "";
          let index = findIndexByName(it.name, jxarr);
          if (index === -1) {
            return;
          }
          const _data = Object.assign(jxarr[index], it);

          myIcons = L.divIcon({
            html: [
              "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='",
              pointUrl,
              "'/><img class='nopx-",
              _data.className,
              "' src='",
              _data.fximg,
              "'/><div class='nopx-" + _data.className + "-box'>",
              //   "<img class='nopx-pic1' src='",
              //   require("images/map/ld/" + _data.name + "1.png"),
              //   "'/>",
              "<img src='",
              require("images/map/ld/" + _data.name + ".png"),
              "'/>",
              "</div></div></div>",
            ].join(""),
            className: "zhu-div-icon",
            iconAnchor: [6, 52],
          });
          //   myIcons = L.divIcon({
          //     html:
          //       "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='" +
          //       pointUrl +
          //       "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
          //       it.name +
          //       "</span></div></div></div>",
          //     className: "zhu-div-icon"
          //   });

          let pointLayer = L.marker([it.latitude, it.longitude], {
            icon: myIcons,
            attributes: it,
          }).addTo(this.pointLayer);
          //   this.kjArr.push(this.pointLayer);
          pointLayer.on("click", (e) => {
            const data = e.sourceTarget.options.attributes;
            this.toshowRightDt(data.name);
          });
        }
      });
      this.map.addLayer(this.pointLayer);
    },
    toshowRightDt(name) {
      if (sessionStorage.getItem("lgyData") && this.t61List.length === 0) {
        this.t61List = JSON.parse(sessionStorage.getItem("lgyData"));
      }
      let index = findIndexByName(name, this.t61List);
      if (index === -1) {
        return;
      }
      get("/api/restful/findByIds?id=" + this.t61List[index].id).then((res) => {
        if (res.websiteNewsFiles instanceof Array) {
          this.showRightDt(
            Object.assign({}, this.t61List[index], {
              orgCompanyFiles: res.websiteNewsFiles,
            })
          );
        } else {
          this.showRightDt(
            Object.assign({}, this.t61List[index], { orgCompanyFiles: [] })
          );
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="stylus" scoped>
.mapDiv
    background url('~@/assets/images/map/ld/bg.png') center center no-repeat
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9
    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none
    >>>.leaflet-bottom
        display none
    .ncDetail
        position absolute
    >>>
        .zhu-div-icon
            color #fff
        .indicator-box
            position relative
        .indicator-box:hover
            z-index 1000
        .zhu-div-text
            position absolute
            height 30px
            display flex
            justify-content center
            align-items center
            width 0.72rem
        .sLine
            transform translate(28%, -67%)
        .zhu-div-box
            display flex
            justify-content center
            align-items center
            flex-wrap wrap
        .zhu-div-image
            width 31px
        .zhu-div-name
            top -30px
            text-align center
        .zhus-div-name.hide
            display none
        .zhus-div-name
            z-index 9
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            padding 2px 10px
            white-space nowrap
        .yellow
            background-color rgba(0, 126, 120, 0.8)
        .nopx-left-btm
            position absolute
            left -120px
            top 17px
        .nopx-left-top
            position absolute
            left: -138px;
            top: -50px;
        .nopx-top
            position absolute
            left: -18px;
            top: -171px;
        .nopx-top-box
            position absolute
            top -180px
            transform: translateY(-50%);
        .nopx-right-top
            position absolute
            left 14px
            top -19px
        .nopx-right-btm
            position absolute
            left: 14px;
            top: 18px;
        .nopx-right-btm0
            position absolute
            left: 14px;
            top: 10px;
        .nopx-right-top-box
            position absolute
            left 144px
            transform: translateY(-50%);
        .nopx-right-btm-box
            position absolute
            left 120px
            bottom -150px
        .nopx-right-btm0-box
            position absolute
            left 179px
            bottom -64px
        .nopx-left-top-box
            position absolute
            left -64px
            transform: translateX(-100%);
            top: -178px;
        .nopx-left-btm-box
            position absolute
            left: -105px;
            transform: translateX(-100%);
            bottom: -115px;
        .nopx-pic1
            position absolute
            top -50px

        .ztgh-div-icon
            color #fff
            z-index 970 !important
        .indicator-box
            position relative
        .ztgh-div-image
            position relative
            width 0.1rem
            height 0.1rem
        .ico_sf
            width 0.11rem
            height 0.11rem
        .ztgh-div-text
            position absolute
            width 1.3rem
            height 30px
            display flex
            justify-content center
            align-items center
        .mys-div-right
            top -18px
            left -0.2rem
            text-align center
        .mys-div-left
            text-align center
            top -18px
            right 0.25rem
        .ztgh-div-name
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, 0.8)
            padding 2px 8px
        .ztgh-div-name:hover
            z-index 999
            font-size 0.09rem
        .ztgh-div-names
            font-size 0.08rem
            color #FFF
            position absolute
            width 1.2rem
            text-shadow -1px 0 #FF770C, 0 1px #FF770C, 1px 0 #FF770C, 0 -1px #FF770C
        .ztgh-div-names:hover
            z-index 999
            font-size 0.09rem
        .sLine
            transform translate(-50%, -50%)
        .mys-div-s
            top -25px
            left -0.35rem
            text-align center
        img
            display inline-block
        .ztgh1-div-left
            position absolute
            top -15px
            right 0
            img
                width 100px
            span
                text-align right
                position absolute
                right 100px
                top -11px
        .ztgh1-div-right
            transform rotateY(180deg)
            position absolute
            top -16px
            left 7px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
        .ztgh-div-left
            position absolute
            top -15px
            right 0
            img
                width 100px
            span
                text-align right
                position absolute
                right 100px
                top -11px
        .ztgh-div-right
            transform rotateY(180deg)
            position absolute
            top 6px
            left 24px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
        .zxd-div-right
            transform rotateY(180deg)
            position absolute
            top -9px
            left 18px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
</style>
